import { IconDatabase, IconStack2 } from '@tabler/icons-react';
import { TFunction } from 'i18next';
import { getKpiObjectLabel } from '@/utils/kpi-dashboard.utils';
import { KpiObjectType } from '@/api/entities/kpi';

interface EvaluatedImagesCardProps {
  t?: TFunction<undefined>;
  type: KpiObjectType;
  evaluatedImages: number;
  classCount: number;
}

export const EvaluatedImagesCard = ({
  t,
  type,
  evaluatedImages,
  classCount,
}: EvaluatedImagesCardProps) => (
  <div className="rounded-xl border border-gray-DBDFE9 bg-white p-5">
    <div className="flex items-center gap-2">
      <IconDatabase className="-mt-0.5 h-5 w-5" stroke={2} />
      <span className="text-2sm font-semibold uppercase tracking-wider">
        {t('evaluatedImages')}
      </span>
    </div>
    <p className="mt-3 text-4xl font-bold text-black-071336 tabular-nums">
      {evaluatedImages.toLocaleString('fr-FR')}
    </p>
    <div className="mt-4 flex items-center gap-2 text-2sm text-gray-78829D">
      <IconStack2 className="h-4.5 w-4.5" stroke={2} />
      {t('objectsCount', {
        value: classCount,
        objects: getKpiObjectLabel(t, type, classCount),
      })}
    </div>
  </div>
);
